import { WizardActionType } from "models/actionTypes/wizardActionTypes";
import { ContextConstants } from "utils/constants";
import { WizardContextState } from "models/propTypes/wizardPropTypes";

export const WizardReducer = (state: WizardContextState, action: WizardActionType): WizardContextState => {
  switch (action.type) {
    case ContextConstants.WizardActions.MOVE_NEXT: {
      return { ...state, currentStep: state.currentStep + 1 };
    }
    case ContextConstants.WizardActions.MOVE_PREV: {
      return { ...state, currentStep: state.currentStep - 1 };
    }
    case ContextConstants.WizardActions.SET_CURRENT_STEP: {
      return { ...state, currentStep: action.payload };
    }
    case ContextConstants.WizardActions.SET_NUMBER_OF_STEPS: {
      return { ...state, numOfSteps: action.payload };
    }
  }
};
